import React from "react";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Why Enerflo VSR?";

const WhyVsr = () => (
  <div className="bg-gray-100">
    <HeroSection title={title}>
      <div className="grow flex flex-col items-center">
        <HeroSection.Content className="w-full md:text-center space-y-4">
          <HeroSection.Header className="font-bold text-navy">
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>
          <br />
          <HeroSection.Description>
            At Enerflo, our mission is to lower the cost of solar by driving efficiency through technology and
            automation. VSR extends that mission to the very first customer touchpoint — delivering a smarter, faster,
            and more affordable way to generate solar leads.
          </HeroSection.Description>
          <br />
          <HeroSection.Description>
            With Enerflo VSR, you’re not just adding a tool — you’re unlocking inside sales in a box that scales your
            business, improves margins, and helps drive the adoption of solar across the U.S.
          </HeroSection.Description>
        </HeroSection.Content>
      </div>
    </HeroSection>
  </div>
);

export default WhyVsr;
